var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4404 4.86217C12.1109 4.53487 11.5766 4.53488 11.2471 4.86217C10.9176 5.18947 10.9176 5.72012 11.2471 6.04742L17.963 12.6167L11.2471 19.186C10.9176 19.5133 10.9176 20.0439 11.2471 20.3712C11.5766 20.6985 12.1109 20.6985 12.4404 20.3712L19.7529 13.2093C20.0824 12.882 20.0824 12.3514 19.7529 12.0241L12.4404 4.86217Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44037 4.86217C5.11087 4.53487 4.57663 4.53488 4.24713 4.86217C3.91762 5.18947 3.91762 5.72012 4.24713 6.04742L10.963 12.6167L4.24713 19.186C3.91763 19.5133 3.91763 20.0439 4.24713 20.3712C4.57664 20.6985 5.11087 20.6985 5.44037 20.3712L12.7529 13.2093C13.0824 12.882 13.0824 12.3514 12.7529 12.0241L5.44037 4.86217Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronRight);
export default __webpack_public_path__ + "static/media/double-chevron-right.719d1dc9.svg";
export { ForwardRef as ReactComponent };